import { DataDeliveryAdminOrganizationMetadataService, OrganizationMetadataDTO } from '@om1/falcon-api'
import { handleApiError } from '@om1/falcon-api/utils'
import { call, put } from 'redux-saga/effects'
import { generalSettingsActions } from '../state/general-settings'

export function createCreateOrganizationSettingsSaga() {
    return function* (action: ReturnType<typeof generalSettingsActions.createOrganizationSettings>) {
        try {
            yield put(generalSettingsActions.setOrganizationSettingsSaving({ saving: true }))
            const createdMetadata: OrganizationMetadataDTO = yield call(
                DataDeliveryAdminOrganizationMetadataService.createDataDeliveryOrganizationMetadataPost,
                {
                    requestBody: action.payload.data
                }
            )
            yield put(generalSettingsActions.updateOrganizationSettingsSuccess({ organizationMetadata: createdMetadata }))
        } catch (error) {
            yield handleApiError(error)
        } finally {
            yield put(generalSettingsActions.setOrganizationSettingsSaving({ saving: false }))
        }
    }
}
